import $ from 'jquery';
export const DESKTOP_GRID_COLUMNS = 3;
export const MOBILE_GRID_COLUMNS = 2;
const positionsByRoot = new WeakMap();
// Accept HTMLElement | JQuery | unknown, return HTMLElement or null
const resolveRoot = (root)=>{
    if (root instanceof HTMLElement) return root;
    // jQuery object?
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    if (root && typeof root === 'object' && root.jquery) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const el = root[0];
        return el instanceof HTMLElement ? el : null;
    }
    return null;
};
const ensurePositionsMap = (root)=>{
    let m = positionsByRoot.get(root);
    if (!m) {
        m = new Map();
        positionsByRoot.set(root, m);
    }
    return m;
};
export const savePositions = (baseName, selector, rootMaybe)=>{
    const root = resolveRoot(rootMaybe);
    if (!root) {
        console.warn('[promo-tiles] savePositions: invalid root', rootMaybe);
        return;
    }
    const map = ensurePositionsMap(root);
    $(root).find(selector).each(function() {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const el = this;
        // Optional marker (kept, but not relied upon)
        if (!el.dataset.ptId) {
            el.dataset.ptId = `${baseName}-${Math.random().toString(36).slice(2, 10)}`;
        }
        const parent = el.parentElement;
        if (!parent) return;
        const index = Array.prototype.indexOf.call(parent.children, el);
        map.set(el, {
            parent,
            index
        });
    });
};
export const resetElementPositions = (selector, rootMaybe)=>{
    const root = resolveRoot(rootMaybe);
    if (!root) {
        console.warn('[promo-tiles] resetElementPositions: invalid root', rootMaybe);
        return;
    }
    const map = positionsByRoot.get(root);
    if (!map) return;
    $(root).find(selector).each(function() {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const el = this;
        const pos = map.get(el);
        if (!pos) return;
        if (!document.contains(pos.parent)) return;
        const ref = pos.parent.children[pos.index] || null;
        pos.parent.insertBefore(el, ref);
    });
};
export const movePromoTiles = (promoTilesSelector, productGridSelector, multiplier, rootMaybe, useMobileRowIndex = false)=>{
    const root = resolveRoot(rootMaybe);
    if (!root) {
        console.warn('[promo-tiles] movePromoTiles: invalid root', rootMaybe);
        return;
    }
    // 1) Reset back to original positions (so we always start clean)
    resetElementPositions(promoTilesSelector, root);
    // 2) Static snapshot of product items (NO promo slots in this list)
    const $products = $(root).find(productGridSelector);
    if (!$products.length) return;
    const products = $products.toArray() // <-- static; won't change as we insert
    ;
    const $container = $products.first().parent();
    // 3) Collect and sort promo slots by target row (ascending)
    const slots = $(root).find(promoTilesSelector).toArray().map((el)=>{
        const $el = $(el);
        const rowAttr = useMobileRowIndex ? 'row-index-mobile' : 'row-index';
        const fallbackAttr = useMobileRowIndex ? 'row-index' : 'row-index-mobile';
        const primaryRow = parseInt(String($el.data(rowAttr)), 10);
        const fallbackRow = parseInt(String($el.data(fallbackAttr)), 10);
        const row = Number.isFinite(primaryRow) ? primaryRow : fallbackRow;
        const attrSpan = parseInt(String($el.data('col-span')), 10);
        const classSpan = $el.hasClass('promo-tiles-slot--span2') ? 2 : 1;
        const rawSpan = Number.isFinite(attrSpan) ? attrSpan : classSpan;
        // optional col span support; defaults to 1
        const span = Math.max(1, Math.min(rawSpan, multiplier));
        return Number.isFinite(row) ? {
            $el,
            row,
            span
        } : null;
    }).filter((x)=>!!x).sort((a, b)=>a.row - b.row);
    if (!slots.length) return;
    // 4) Track how many promo "cells" earlier rows have already consumed
    const consumedByRow = new Map();
    // 5) Place each slot against the static product snapshot
    for (const { $el , row , span  } of slots){
        // cells consumed in rows strictly before `row`
        let priorCells = 0;
        for (const [r, cells] of consumedByRow){
            if (r < row) priorCells += cells;
        }
        // start-of-row cell among pure products
        const rowStartCell = row * multiplier;
        // adjust by earlier promo cells so we don't drift down a row
        const targetCell = Math.max(0, rowStartCell - priorCells);
        // Insert relative to the *static* products array
        $el.detach();
        if (targetCell <= 0) {
            if (products[0]) {
                $el.insertBefore(products[0]);
            } else {
                $container.append($el);
            }
        } else if (targetCell < products.length) {
            // after the (targetCell - 1)-th product
            const targetProduct = products[targetCell - 1];
            if (targetProduct) {
                $el.insertAfter(targetProduct);
            } else {
                $container.append($el);
            }
        } else {
            // beyond last product -> append to container
            $el.appendTo($container);
        }
        var _consumedByRow_get;
        // mark cells consumed in this row for later adjustments
        consumedByRow.set(row, ((_consumedByRow_get = consumedByRow.get(row)) !== null && _consumedByRow_get !== void 0 ? _consumedByRow_get : 0) + span);
    }
};
export const isMobile = (rootMaybe)=>{
    const root = resolveRoot(rootMaybe);
    if (!root) return window.innerWidth < 768;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const grid = root.querySelector('.js-product-grid');
    if (!grid) return window.innerWidth < 768;
    const gtc = getComputedStyle(grid).getPropertyValue('grid-template-columns') || '';
    if (!gtc) return window.innerWidth < 768;
    const cols = gtc.includes('minmax') ? (gtc.match(/minmax/g) || []).length : gtc.trim().split(/\s+/).length;
    return cols === MOBILE_GRID_COLUMNS;
};
export const nextFrame = ()=>new Promise((r)=>requestAnimationFrame(()=>requestAnimationFrame(()=>r())));
export const getRootFromAny = (el)=>{
    const section = el === null || el === void 0 ? void 0 : el.closest('.shopify-section');
    if (section instanceof HTMLElement) {
        return section;
    }
    const fallback = document.querySelector('.shopify-section');
    if (fallback instanceof HTMLElement) {
        return fallback;
    }
    return document.body;
};
